// extracted by mini-css-extract-plugin
export var baseCollapse = "BaseCollapse-module--baseCollapse--2pYOO";
export var baseCollapse__container = "BaseCollapse-module--baseCollapse__container--38ll3";
export var baseCollapse__body = "BaseCollapse-module--baseCollapse__body--1cQaZ";